<script>
    import { invalidateAll, goto } from '$app/navigation';
    import { page } from '$app/stores';
    import { onMount } from 'svelte';

    import { button_enable, button_disable, handleFetch, handleFetchReject, server_name, checkNewPassword } from "$lib/app/lib.js";
    import { is_email, is_username, randomPassword } from "$lib/universal/lib.js";

    import {
        PUBLIC_GOOGLE_SIGNIN_CLIENT_ID,
        PUBLIC_APPLE_CLIENT_ID_WEB
     } from '$env/static/public';

    import EyePasswordToggle from "$lib/app/EyePasswordToggle.svelte";

    const pass_placeholder = "passw"+randomPassword();

    let {
        authentication_required = false,
        show_login = $bindable(false),
        show_signup = $bindable(false)
    } = $props();

    let googleButtonWrapper = null;

    let usernameEl = $state(undefined);
    let saveUsername = $state();
    let savePassword = $state();
    let saveEmail = $state();

    onMount(() => {
        if (window.google && google.accounts && google.accounts.id) {
            google.accounts.id.initialize({
                client_id: PUBLIC_GOOGLE_SIGNIN_CLIENT_ID,
                login_uri: server_name("/finish_auth"),
                ux_mode: "redirect",
                state: $page.url.pathname,
            });

            const original_google_button = document.getElementById("original-google-button");

            google.accounts.id.renderButton(original_google_button,
                {
                    theme: "filled_black",
                    size: "large",
                    width: 320,
                    locale: "en_EN"
                }
            );

            const googleLoginWrapperButton = original_google_button.querySelector("div[role=button]");

            googleButtonWrapper = {
                click: () => { googleLoginWrapperButton.click(); }
            };

            ///google.accounts.id.prompt(); // also display the One Tap dialog
        }
    });

    $effect(() => {          // focusOnUsername()
        if(!usernameEl) {
            usernameEl = document.getElementById('username') || document.getElementById('new-username');
            if(usernameEl) {
                usernameEl.focus(); // Should run once per form open
            }
        }
    });

    function goSignupOrLogin(e, {signup}) {
        e.preventDefault();
        show_signup = signup;
        show_login = !signup;
        usernameEl = undefined;
    }

    function goSignup(e) {
        goSignupOrLogin(e, { signup: true });
    }

    function goLogin(e) {
        goSignupOrLogin(e, { signup: false });  // !signup === login
    }
    
    function handleGoogleLogin() {
        if(googleButtonWrapper) {
            googleButtonWrapper.click();
        } else {
            console.log("googleButtonWrapper is not set");
        }
    }

    function handleLoginForm(e) {
        e.preventDefault();
        //console.log("handleLoginForm");
        
        const error_in_api = document.getElementById("login_error_in_api");
        const the_button = document.getElementById("b_login");
        const formData = new FormData(document.getElementById('login-form'));
        button_disable(the_button /*"b_login"*/);

        //fetch('/api', {
        fetch('/_api/auth/login', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        })
        //.then(fetchHandler)
        .then(handleFetch, handleFetchReject)
        .then((data) => { // Parsed JSON passed as `data`
            if(data["error"]) {
                error_in_api.innerHTML = data["error"];
                //button_enable(the_button /*"b_login"*/);
                //$session = null;
                //console.log("login failed");
            } else if(data["message"]) {
                error_in_api.classList.remove("is-danger");
                error_in_api.classList.add("is-success");
                error_in_api.innerHTML = data["message"];
                //$session = data;
                //console.log("just logged in as "+JSON.stringify(data));
                //button_enable(the_button /*"b_login"*/);
                show_login = show_signup = false;
                //if(/\/user\//.test($page.url.pathname)) {
                //    goto("/user/me");
                //}

                //console.log("just logged in");

                /*
                console.log("goto = /user/"+$session.userpage);
                goto("/user/"+$session.userpage);
                */
            }
            button_enable(the_button /*"b_login"*/);
            invalidateAll();
            //button_enable(the_button /*"b_login"*/);
        });
        /*
        .catch((error) => {
            error_in_api.innerHTML = error;
            button_enable(the_button); // b_login
        });*/
    }

    function checkNewUsername(allow_empty) {
        let error = "";
        const username = document.getElementById("new-username");
        //const usernameRE = /^\s*[a-z0-9._~-]+\s*$/i;
        const usernameOK = username.value.length === 0 || is_username(username.value); //usernameRE.test(username.value);
        if((!allow_empty || username.value.trim().length > 0) && (username.value.trim().length < 3 || username.value.trim().length > 16)) {
            error = "Username must be 3-16 characters long"
        } else {
            error = usernameOK ? "" : "Only allowed latin letters, digits or symbols -._~";
        }

        if(error) {
            document.getElementById("error_in_username").innerHTML = error;
            username.classList.add("is-danger");
        } else if(username.value.trim().length > 0 || !allow_empty) {
            //console.log(allow_empty);
            //console.log(username.value.trim().length);

            const formData = new FormData();
            formData.append('username', username.value);
            //formData.append('check_username', 'yes');

            //fetch('/api', {
            fetch('/_api/auth/check-username', {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            })
            //.then(fetchHandler)
            .then(handleFetch, handleFetchReject)
            .then((data) => { // Parsed JSON passed as `data`
                if(data["error"]) {
                    document.getElementById("error_in_username").innerHTML = data["error"];
                    username.classList.add("is-danger");
                } else {
                    document.getElementById("error_in_username").innerHTML = ""; //data["message"];
                    username.classList.remove("is-danger");
                }
            });
            /*.catch((e) => {
                document.getElementById("error_in_username").innerHTML = e;
                username.classList.add("is-danger");
            });*/

        }
    }

    function checkNewEmail(allow_empty) {
        const email = document.getElementById("new-email");
        //const emailRE = /^\s*[a-z0-9!#$%&'*+/=?^_‘{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_‘{|}~-]+)*@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z0-9][a-z0-9-]*[a-z0-9]\s*$/i;
        const emailOK = (allow_empty && email.value.length === 0) || is_email(email.value); //emailRE.test(email.value);
        //return (document.getElementById("error_in_email").innerHTML = emailOK ? "" : "Please enter a valid email");

        if(!emailOK) {
            document.getElementById("error_in_email").innerHTML = "Please enter a valid email";
            email.classList.add("is-danger");
        } else if(email.value.trim().length > 0 || !allow_empty) {
            //console.log(allow_empty);
            //console.log(email.value.trim().length);

            const formData = new FormData();
            formData.append('email', email.value);
            //formData.append('check_email', 'yes');

            //fetch('/api', {
            fetch('/_api/auth/check-email', {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            })
            //.then(status)
            //.then(json) // Parse server response as JSON
            //.then(fetchHandler)
            .then(handleFetch, handleFetchReject)
            .then((data) => { // Parsed JSON passed as `data`
                if(data["error"]) {
                    document.getElementById("error_in_email").innerHTML = data["error"];
                    email.classList.add("is-danger");
                } else {
                    document.getElementById("error_in_email").innerHTML = "";
                    email.classList.remove("is-danger");
                }
            });/*
            .catch((e) => {
                document.getElementById("error_in_email").innerHTML = e;
                email.classList.add("is-danger");
            })*/
        }
    }

    function handleSignupForm(e) {
        //function process_signup_form(e, the_button) {
        e.preventDefault();

        const error_in_api = document.getElementById("signup_error_in_api");
        const the_button = document.getElementById("b_signup");

        checkNewUsername(false);
        checkNewEmail(false);
        checkNewPassword(false);  // Has side effects: directly access DOM's new-password and error_in_password

        if(document.getElementById("error_in_username").innerHTML +
            document.getElementById("error_in_email").innerHTML +
            //document.getElementById("error_in_password2").innerHTML +
            document.getElementById("error_in_password").innerHTML) {
                //console.log("ignoring the click on Submit button because of fill-in errors");
                return;
        }

        const formData = new FormData(document.getElementById('signup-form'));
        button_disable(the_button);

        //fetch('/api', {
        fetch('/_api/auth/signup', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
            referrerPolicy: 'origin-when-cross-origin',
        })
        //.then(status)
        //.then(json) // Parse server response as JSON
        //.then(fetchHandler)
        .then(handleFetch, handleFetchReject)
        .then((data) => { // Parsed JSON passed as `data`
            if(data["error"]) {
                error_in_api.classList.remove("is-success");
                error_in_api.classList.add("is-danger");
                error_in_api.innerHTML = data["error"];
            } else if(data["message"]) {
                error_in_api.classList.remove("is-danger");
                error_in_api.classList.add("is-success");
                error_in_api.innerHTML = data["message"];

                // no field check when moving away from the signup form 
                document.getElementById('new-username')?.removeAttribute('onblur'); // stop short-time flashing of error the "username is in use"
                document.getElementById('new-email')?.removeAttribute('onblur');    // // stop short-time flashing of error the "email is in use"
                //document.getElementById('password').removeAttribute('onblur');    

                //window.location.replace("/signup?greatsuccess=1");
                window.location.replace("/user/me");
            }
            //console.log(JSON.stringify(data));
            button_enable(the_button);
        });/*
        .catch((error) => {
            error_in_api.classList.remove("is-success");
            error_in_api.classList.add("is-danger");
            error_in_api.innerHTML = error;
            button_enable(the_button);
        })*/
    }

    function handleAppleLogin(e) {
        e.preventDefault();
        const the_button = e.currentTarget;
        button_disable(the_button);
        const url = new URL("https://appleid.apple.com/auth/authorize");

        url.searchParams.set("client_id", PUBLIC_APPLE_CLIENT_ID_WEB);
        url.searchParams.set("redirect_uri", server_name('/_api/auth/apple-login'));
        url.searchParams.set("response_type", "code");
        url.searchParams.set("scope", "name email");
        url.searchParams.set("response_mode", "form_post");

        // Fallback in case user cancels and stays on page
        setTimeout(() => {
            button_enable(the_button);
        }, 6000);

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                // If user comes back and the button is still disabled
                if (the_button && the_button.disabled) {
                    button_enable(the_button);
                }
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            }
        });


        window.location = url.toString();
    }

</script>

{#snippet FormClose()}
<button id='form-close' type=button class='delete mt-1' aria-label='close' style='align-self:flex-start;'
    onclick={(e) => {
        e.preventDefault();
        if(authentication_required) {
            history.back();
        } else {
            show_signup = show_login = false;
        }
    }}
>
</button>
{/snippet}

<!--the google button always mounted, when LoginSignupForm is on the screen. So use {#if !session?.id} outside-->
<div id="original-google-button" class="hide-google-button"></div>

{#if show_login || show_signup}
<div id="login-signup-form" class="modal is-active">

    <div class="modal-background"  style="background-color:rgba(10,10,10,0.5);"></div>
    <div class="modal-content card" style="width: auto;">
        {#if show_login}
        <form id="login-form" novalidate="novalidate" onsubmit={handleLoginForm} method=POST class="column">
            <div class="level is-mobile"><h1 class="title fr1 mb-0">Log In</h1>{@render FormClose()}</div>
            <h2 class="subtitle fr2">
                New users: please <a class="has-text-primary" href="/signup" onclick={goSignup} style="text-decoration: underline; text-underline-offset: 4px;">sign up</a>
            </h2>
            <input type="hidden" id="login" name="login" value="yes">

            <div class="field" style="width:320px;">
                <label for="username" class="label" >Username or email</label>
                <div class="control">
                    <input class="input" id="username" type="text" name="username" bind:value={saveUsername} autocomplete="username" autocapitalize="off" autocorrect="off" maxlength="50">
                </div>
            </div>

            <div class="field" style="width:320px;">
                <label for="password" class="label">Password</label>
                <div class="control has-icons-right">
                    <input class="input" id="current-password" type="password" name="password" bind:value={savePassword} autocomplete="current-password" maxlength="128">
                    <span class="icon is-small is-right">
                        <EyePasswordToggle target_id='current-password'/>
                    </span>
                </div>
            </div>

            <div class="field" style="width:320px;">
                <div class="control">
                    <button id="b_login" class="button is-link" style="width:320px;" type="submit">Log In</button>
                </div>
                <div id="login_error_in_api" class="help is-danger"><a href="/password?forgot=yes" onclick={()=>{show_login=show_signup=false}}>Forgotten password?</a></div>
            </div>

        </form>
        
        <!--        -->
        <!-- SIGNUP -->
        <!--        -->
        {:else}

        <form id="signup-form" novalidate="novalidate" onsubmit={handleSignupForm} method=POST class="column">
            <div class="level is-mobile"><h1 class="title fr1 mb-0">Sign Up</h1>{@render FormClose()}</div>
            <h2 class="subtitle fr2">
                Already users: please <a href="/login" onclick={goLogin} style="text-decoration: underline; text-underline-offset: 4px;">log in</a>
            </h2>
            <input type="hidden" id="signup" name="signup" value="yes">

            <div class="field" style="width:320px;">
                <label for="new-username" class="label">Username</label>
                <div class="control">
                    <input id="new-username" class="input" type="text" name="username" bind:value={saveUsername} autocomplete="username" autocapitalize="off" autocorrect="off" maxlength="50" placeholder="username" onblur={() => checkNewUsername(true)}>
                </div>
                <div id="error_in_username" class="help is-danger"></div>
            </div>

            <div class="field" style="width:320px;">
                <label for="new-email" class="label">Your email address</label>
                <div class="control">
                    <input id="new-email" class="input" type="text" name="email" bind:value={saveEmail} autocomplete="email" autocapitalize="off" autocorrect="off" maxlength="254" placeholder="mailbox@example.com" onblur={() => checkNewEmail(true)}>
                </div>
                <div id="error_in_email" class="help is-danger"></div>
            </div>

            <div class="field" style="width:320px;">
                <label for="new-password" class="label">Password</label>
                    <div class="control has-icons-right">
                        <input id="new-password" class="input" type="password" name="password" bind:value={savePassword} autocomplete="new-password" maxlength="128" placeholder={pass_placeholder} onblur={() => checkNewPassword(true)}>
                        <span class="icon is-small is-right">
                            <EyePasswordToggle target_id='new-password'/>
                        </span>
                    </div>
                <div id="error_in_password" class="help is-danger"></div>
            </div>

            <div class="field" style="width:320px;">
                <div class="control">
                    <button id="b_signup" class="button is-primary" style="width:320px;" type="submit">Sign up</button>
                </div>
                <div id="signup_error_in_api" class="help is-danger"></div>
            </div>

        </form>
        {/if}

        <div class="column">
            <span style="width:320px" class='hr has-text-grey-light my-4 been-oblique'>or</span>
            <!--data-login_uri="https://beeneverywhere.net/finish_auth?uri={uri}"-->
            <!--data-login_uri="https://{location.hostname}/finish_auth?uri={$uri}"-->
            <!--div id="continue-with-google" style="width:320px; height:80px !important;">
                <div id="g_id_onload"
                    data-client_id={PUBLIC_GOOGLE_SIGNIN_CLIENT_ID}
                    data-login_uri={data_login_uri}
                    data-auto_prompt="false"
                    style="width:320px; height:0px !important;"
                    >
                </div>
                <div class="g_id_signin"
                    style="width:320px; height:44px !important;"
                    data-type="standard"
                    data-size="large"
                    data-theme="filled_black"
                    data-text="continue_with"
                    data-shape="rectangular"
                    data-width="320"
                    data-locale="en"

                >
                </div>
            </div-->

            <div class="field continue-with-block" style="width:320px;">
                <div class="control">
                    <button class="button is-outlined is-dark" style="width:320px;" onclick={handleGoogleLogin}>
                        <svg class='svg-icon'><use xlink:href='/i/fa.svg#google-google'></use></svg>
                        &nbsp;&nbsp;
                        <span>{#if show_login}Sign in{:else}Sign up{/if} with Google</span>
                    </button>
                </div>

                <div class="control mt-4">
                    <button class="button is-outlined is-dark" style="width:320px;" onclick={handleAppleLogin}>
                        <svg class='svg-icon is-big is-apple-icon'><use xlink:href='/i/fa.svg#apple'></use></svg>
                        &nbsp;&nbsp;
                        <span>{#if show_login}Sign in{:else}Sign up{/if} with Apple</span>
                    </button>
                </div>
            </div>


            <!--div id="continue-with-google">
                <div id="buttonDiv"/>
            </div-->
            <div class="help">
                By signing up you are agreeing to our
                <a id="t-and-c" target=_blank href="/info/terms" onblur={() => {
                        let firstElementInOverlay = document.getElementById("form-close");
                        if(firstElementInOverlay) firstElementInOverlay.focus();
                    }}>T&C</a>
            </div>


        </div>
    </div>

</div>
{/if}



<style> 

@media (prefers-color-scheme: dark) {
    .is-apple-icon {
        color: #DDD;
    }
}

.hide-google-button {
    display: none !important;
}


.hr {
    display: flex;
    flex-direction: row;
}
.hr:before, .hr:after{
    content: "";
    flex: 1 1;
    border-bottom: 1px solid;
    margin: auto;
}
.hr:before {
    margin-right: 10px
}
.hr:after {
    margin-left: 10px
}

</style>  
  
  
  